export default function setDateToAction(dateTo) {
    return {
        type: 'SET_DATETO',
        payload: dateTo
    }
}